<script lang="ts">
	import Pagination from '#components/pagination.svelte'
	import { attrs } from '#library/attrs.ts'
	import CardInfo from '#components/card_info.svelte'
	import emblaCarouselSvelte from 'embla-carousel-svelte'
	import { setupTweenOpacity } from '#library/emblaTween.ts'
	import type { EmblaCarouselType } from 'embla-carousel'

	let { blok } = $props()
	let active = $state(0)
	let embla_api: EmblaCarouselType | undefined = $state()

	function onInit(event: CustomEvent) {
		embla_api = event.detail
		if (!embla_api) return

		const removeTweenOpacity = setupTweenOpacity(embla_api)

		embla_api.on('select', () => {
			active = embla_api?.selectedScrollSnap() ?? 0
		})

		embla_api.on('destroy', removeTweenOpacity)
	}
</script>

<section
	class="cardousel {blok.theme}"
	{...attrs(blok)}
	use:emblaCarouselSvelte={{ options: { loop: true, align: 'center' }, plugins: [] }}
	onemblaInit={onInit}
>
	<div class="cards">
		{#each blok.items as { suptitle, title, body, image, theme, shape }, i (i)}
			<div class="item">
				<CardInfo
					{suptitle}
					{title}
					{body}
					{image}
					{theme}
					{shape}
					{i}
					count={blok.paginate ? blok.items.length : undefined}
					inline
				/>
			</div>
		{/each}
	</div>
	<div class="contain">
		<Pagination
			onprev={embla_api?.scrollPrev}
			onnext={embla_api?.scrollNext}
			onpage={embla_api?.scrollTo}
			items={blok.items.length}
			{active}
		/>
	</div>
</section>

<style lang="css">
	.cardousel {
		background-color: var(--c-background, transparent);
		overflow: hidden;
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.cards {
		align-items: center;
		display: flex;
	}

	.item {
		align-items: center;
		display: flex;
		flex: 1 0 100%;
		min-height: 32rem;
		min-width: 0;
		max-width: min(92vw, 66.25rem);
		scroll-snap-align: center;
		user-select: none;

		:global(.shape) {
			max-width: 26.25rem;
			width: 100%;
		}
	}

	.contain {
		display: flex;
		justify-content: center;

		@media (--from-mobile) {
			padding-block: 1.75rem 0;
		}
	}
</style>
